export const GET_UNALLOCATED_ACCOUNTS = `
  mutation ($year: Int!, $month: Int) {
    getUnallocatedAccounts(actualsSearch: {year: $year, month: $month}) {
      data {
        accountId
        accountName
        createdDate
        spending
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
